import React, { useState, useEffect ,useRef} from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ScrollContainer from "react-indiana-drag-scroll";
import API from "../../services/api";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import {
  SlOption,
  SlSelect,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import * as XLSX from "xlsx";
import { toLakhs, getBrandOptions } from "../../utils/constants";
import { formatDateDDMMYYY } from "../../utils/dateFormat";
import { CSVLink } from "react-csv";
import { Toast } from "../../shared/Toast";




function OverallRevenue() {
  const [data, setData] = useState([{}]);
  const [campaignwiseData,setcampaignwiseData]=useState([])
  const [newspapers, setNewspapers] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState("Eenadu");
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [alphaDownloader,setAlphaDownloader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedType, setSelectedType] = useState("all");
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  
  const csvLinkRef = useRef();
  const Headers = [
    { label: "Date", key: "Date" },
    { label: "campaign_name", key: "campaign_name" },
    { label: "Spent", key: "Spent" },
];
  function getDaysInMonth(selectedMonth) {
    if (!selectedMonth) return 30; // Default to 30 days in case of error

    const today = new Date(selectedMonth);
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    // If selected month is the current month, return today's date
    let today_date = new Date();
    if (
      today_date.getFullYear() === currentYear &&
      today_date.getMonth() === currentMonth
    ) {
      return today_date.getDate();
    }

    // Return last date of the selected month
    return new Date(currentYear, currentMonth + 1, 0).getDate();
  }

  const fetchNewspapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        const newspapers = res.data.filter(
          (paper) => paper?.name !== "Way2news"
        );
        setNewspapers([...newspapers]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/sales_reports/overallrevenue",
        method: "POST",
        responseType: "json",
        data: {
          newspaper: selectedNewspaper,
          month: selectedMonth,
          type: selectedType,
        },
      });
      if (res.code === 200) {
        setData(res.data);
        if (res.data.userType !== -1) {
          setSelectedType(`${res.data.userType}`);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };
  
  useEffect(() => {
    if (campaignwiseData.length > 0) {
      csvLinkRef?.current?.link?.click();
    }
  }, [campaignwiseData]);
  const getdownloadData = async () => {
    setDownloadLoader(true);
    try {
      const tableData = [
        ["Date", "Avg Rev Target", "Achieved", "Achieved %", `${selectedNewspaper} Revenue`, `% ${selectedNewspaper} vs W2N`],
        ...Array.from({ length: getDaysInMonth(selectedMonth) }, (_, index1) => {
          const dateKey = `${index1 + 1}-${month}-${year}`;
          const rowData = data?.data?.find(row => row.date === dateKey) || {
            newspaperRevenue: 0,
            way2NewsRevenue: 0,
          };
          const achieved = rowData.way2NewsRevenue;
          const newspaperRevenue = rowData.newspaperRevenue;
          const achievedPercentage =
            achieved && data.avgRevTarget
              ? ((achieved / data.avgRevTarget) * 100).toFixed(2) + "%"
              : "-";
          const newspaperVsW2NPercentage =
            newspaperRevenue && achieved
              ? ((achieved / newspaperRevenue) * 100).toFixed(2) + "%"
              : "-";
      
          return [
            dateKey,
            (data.avgRevTarget).toFixed(2),
            (achieved),
            achievedPercentage,
            (newspaperRevenue),
            newspaperVsW2NPercentage,
          ];
        }),
        [
          "Total",
          (data.avgRevTarget * getDaysInMonth(selectedMonth)),
          (data?.data?.reduce((sum, row) => sum + row.way2NewsRevenue, 0)).toFixed(2),
          (
            (data?.data?.reduce((sum, row) => sum + row.way2NewsRevenue, 0) /
              (data.avgRevTarget * getDaysInMonth(selectedMonth))) *
            100
          ).toFixed(2) + "%",
          (data?.data?.reduce((sum, row) => sum + row.newspaperRevenue, 0)),
          (
            (data?.data?.reduce((sum, row) => sum + row.way2NewsRevenue, 0) /
              data?.data?.reduce((sum, row) => sum + row.newspaperRevenue, 0)) *
            100
          ).toFixed(2) + "%",
        ],
      ];
      

      const worksheet = XLSX.utils.aoa_to_sheet(tableData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Overall Revenue");
      XLSX.writeFile(workbook, `Overallrevenue.xlsx`);
    } catch (error) {
      console.error(error, "Overall Revenue");
    } finally {
      setDownloadLoader(false);
    }
  };
  
  const getAlphaCampaignwiseDownload = async (selectedType,selectedMonth)=>{
    setAlphaDownloader(true);
    console.log(selectedType,selectedMonth);
    try {
      let res = await API({
        url: "/sales_reports/campaignwiseRevenueAlpha",
        method: "POST",
        responseType: "json",
        data: {
          month: selectedMonth,
          type: selectedType,
        },
      });
      if (res.code === 200) {
        if(res.data.length == 0)
          Toast("info",'No Data to Dowload')
        setcampaignwiseData(res.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setAlphaDownloader(false);
    }
  }
  useEffect(() => {
    fetchNewspapers();
  }, []);

  const handleMonthChange = (date) => {
    setSelectedMonth(date);
    setMonth(date.getMonth() + 1);
    setYear(date.getFullYear());
  };
  useEffect(() => {
    fetchData();
  }, [selectedNewspaper, selectedType, selectedMonth]);

  return (
    <>
      <div className="flex gap-3 justify-between">
        <h5>Overall Revenue</h5>
        <aside className="flex gap-3 items-center">
          <SlSelect
            size="small"
            value={selectedType}
            label="Team"
            onSlChange={(e) => {
              setSelectedType(e.target.value);
            }}
          >
            {data?.userType === -1 ? (
              <SlOption value="all">All</SlOption>
            ) : null}
            {getBrandOptions(
              data?.userType,
              localStorage.getItem("email")
            )?.map((type) => (
              <SlOption key={type.value} value={type.value}>
                {type.label}
              </SlOption>
            ))}
          </SlSelect>
          <SlSelect
            label="Newspaper"
            size="small"
            value={selectedNewspaper}
            onSlChange={(e) => setSelectedNewspaper(e.target.value)}
          >
            {newspapers.map((paper) => (
              <SlOption value={paper.name}>{paper.name}</SlOption>
            ))}
          </SlSelect>
          <div className="clientwiserevenue-datepicker max-w-[200px] ">
            <label className="form-label">Select Month</label>
            <DatePicker
              selected={selectedMonth}
              onChange={handleMonthChange}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              className="dateChooser border h-5 rounded-md"
            />
          </div>
          {downloadLoader ? (
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <div
              className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
              onClick={getdownloadData}
            >
              <sl-tooltip content="Download" placement="top">
                <SlIcon library="lucide" name="download" />
              </sl-tooltip>
            </div>
          )}
       <CSVLink
        data={campaignwiseData.map(
          ({campaign_name,date,spent}) => ({
            Date: formatDateDDMMYYY(date),
            campaign_name,
            Spent: spent,
          })
        )}
        headers={Headers}
        filename="campaignwiseSpentAlphareport.csv"
        ref={csvLinkRef}
        className="hidden"
      />
        {selectedType === "5" && (
          alphaDownloader ? (
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <div
              className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
              onClick={() => getAlphaCampaignwiseDownload(selectedType, selectedMonth)}
            >
              <sl-tooltip content="CampaignWiseDownload" placement="top">
                <SlIcon library="lucide" name="download" />
              </sl-tooltip>
            </div>
          )
        )}
        </aside>
      </div>
      <ScrollContainer>
        <table className="table table-bordered tbodyscroll">
          <thead className="bg-yellow-300">
            <tr>
              <th>Date</th>
              <th>Avg Rev Target</th>
              <th>Achieved</th>
              <th>Achieved %</th>
              <th>{selectedNewspaper} Revenue</th>
              <th>% {selectedNewspaper} vs W2N</th>
            </tr>
          </thead>
          {!loader && data?.data?.length > 0 ? (
            <tbody>
              {Array.from(
                { length: getDaysInMonth(selectedMonth) },
                (_, index1) => {
                  const dateKey = `${index1 + 1}-${month}-${year}`;
                  const rowData = data?.data?.find(
                    (row) => row.date === dateKey
                  ) || {
                    newspaperRevenue: 0,
                    way2NewsRevenue: 0,
                  };
                  const achieved = rowData.way2NewsRevenue;
                  const newspaperRevenue = rowData.newspaperRevenue;
                  const achievedPercentage =
                    achieved && data.avgRevTarget
                      ? ((achieved / data.avgRevTarget) * 100).toFixed(2) + "%"
                      : "-";
                  const newspaperVsW2NPercentage =
                    newspaperRevenue && achieved
                      ? ((achieved / newspaperRevenue) * 100).toFixed(2) + "%"
                      : "-";

                  return (
                    <tr key={index1}>
                      <td className="!bg-orange-100">{dateKey}</td>
                      <td title={data.avgRevTarget}>{toLakhs(data.avgRevTarget)}</td>
                      <td title={achieved}>{toLakhs(achieved)}</td>
                      <td>{achievedPercentage}</td>
                      <td title={newspaperRevenue}>{toLakhs(newspaperRevenue)}</td>
                      <td>{newspaperVsW2NPercentage}</td>
                    </tr>
                  );
                }
              )}
              {/* Total Row */}
              <tr>
                <td className="!bg-gray-300 font-bold">Total</td>
                <td title={(data.avgRevTarget * getDaysInMonth(selectedMonth))}>
                  {toLakhs(data.avgRevTarget * getDaysInMonth(selectedMonth))}
                </td>
                <td title={ data?.data?.reduce(
                      (sum, row) => sum + row.way2NewsRevenue,
                      0
                    )}>
                  {toLakhs(
                    data?.data?.reduce(
                      (sum, row) => sum + row.way2NewsRevenue,
                      0
                    )
                  )}
                </td>
                <td>
                  {(
                    (data?.data?.reduce(
                      (sum, row) => sum + row.way2NewsRevenue,
                      0
                    ) /
                      (data.avgRevTarget * getDaysInMonth(selectedMonth))) *
                    100
                  ).toFixed(2) + "%"}
                </td>
                <td title={data?.data?.reduce(
                      (sum, row) => sum + row.newspaperRevenue,
                      0
                    )}>
                  {toLakhs(
                    data?.data?.reduce(
                      (sum, row) => sum + row.newspaperRevenue,
                      0
                    )
                  )}
                </td>
                <td>
                  {((data?.data?.reduce(
                    (sum, row) => sum + row.way2NewsRevenue,
                    0
                  ) /
                    data?.data?.reduce(
                      (sum, row) => sum + row.newspaperRevenue,
                      0
                    )) *
                    100).toFixed(2) +
                    "%"}
                </td>
              </tr>
            </tbody>
          ) : loader ? (
            <TableSkelton rowSpan={15} colspan={6} />
          ) : (
            <NoDataFound colspan={6} />
          )}
        </table>
        ;
      </ScrollContainer>
    </>
  );
}

export default OverallRevenue;
